/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PATHS from '../../../routes/urls';
import RequisitionNotification from '../../staff/shared/layouts/sidebar/manager-and-executives/RequisitionNotification';
import AssetTeamSideBarItem from '../asset-team/sidebar/AssetTeamSideBarItem';
import { AES, enc } from 'crypto-js';
import { useUser } from '../../../hooks/shared/user/useUser';
import FieldSupportSideBarItem from '../field-support/side-bar/FieldSupportSideBarItem';
import AdminNavBarItem from '../super-admin/AdminNavBarItem';

const FibreSideBar = () => {
  const userCountry = sessionStorage.getItem('country');
  const email = sessionStorage.getItem('officialEmail');
  const roleId = Number(sessionStorage.getItem('roleId'));
  const detailsState = {
    name: 'React',
    messagetoken: sessionStorage.getItem('token'),
    messagerole: sessionStorage.getItem('roleId'),
    messagedepartment: sessionStorage.getItem('departmentId'),
    secret: 'Wifirocks123',
    cipher: '',
  };
  const [details, setDetails] = useState(detailsState);
  const { name, messagetoken, messagerole, messagedepartment, secret, cipher } = details;

  const obj = {
    login: messagetoken,
    pass: messagerole,
    department: messagedepartment,
  };

  const ciph = AES.encrypt(JSON.stringify(obj), secret).toString();

  const span13 = (tabName) => (
    <span className="text-uppercase" style={{ fontSize: '14px' }}>
      {tabName}
    </span>
  );
  const groupIcon = 'https://res.cloudinary.com/tizeti/image/upload/v1542971013/Group-3.png';



  return (
    <div className="s-layout__sidebar">
      <Link className="s-sidebar__trigger" to="#">
        <i className="fa fa-bars mr-3" />
      </Link>
      <nav className="s-sidebar__nav">
        <Link className="navbar-brand-logo" to="/fibre-team">
          <img src="https://res.cloudinary.com/tizeti/image/upload/v1542971047/Tizeti-Logo.png" alt="homepage" />
        </Link>
        <ul>
          <span className="p-0 mt-3">
            <AssetTeamSideBarItem url="/fibre-team" name="Overview" />
            
            <li className="s-sidebar__nav-link">
              {' '}
              <a href={`https://os.tizeti.com/main/#/overview?ciph=${ciph}`} target="_blank" className="make-bold">
                <span>
                  <img src="https://res.cloudinary.com/teewhy/image/upload/v1548923169/configr_d.fw.png" alt="img" />
                </span>
                <small>New system (Beta v2.0)</small>
              </a>
            </li>

                        

           
  <li className="s-sidebar__nav-link">
              <Link to="/teams" target="_self">
                <span>
                  <img src="https://res.cloudinary.com/tizeti/image/upload/v1542971014/Group-6.png" alt="img" />
                </span>
                <small>Teams</small>
              </Link>
            </li>

            <li className="s-sidebar__nav-link">
              {' '}
              <Link to="/fibre-team/customers" target="_self">
                <span>
                  <img src="https://res.cloudinary.com/tizeti/image/upload/v1542971010/Group_2.1.png" alt="img" />
                </span>
                <small>Customers</small>
              </Link>
            </li>
           
            {roleId > 1 ? (
              <li className="s-sidebar__nav-link">
                {' '}
                <Link to="/fibre-team/customer-details" target="_self">
                  <span>
                    <img src="https://res.cloudinary.com/tizeti/image/upload/v1542971010/Group_2.1.png" alt="img" />
                  </span>{' '}
                  Customer Details
                </Link>
              </li>
            ) : (
              ''
            )}

            <FieldSupportSideBarItem
              url="/fibre-team/active-and-inactive"
              name="Active/Inactive Customers"
            />

            <FieldSupportSideBarItem url={PATHS.FIELD_SUPPORT_INSTALLATION_OVERVIEW} name="Installations" />
           

          

         
           
           

            <li className="s-sidebar__nav-link">
              <Link to="/shared/basestations" target="_self">
                <span>
                  <img src="https://res.cloudinary.com/tizeti/image/upload/v1542971012/Group-1.png" alt="img" />
                </span>
                <small>All Basestations</small>
              </Link>
            </li>

            <li className="s-sidebar__nav-link">
              <Link to="/fibre-team/basestations" target="_self">
                <span>
                  <img src="https://res.cloudinary.com/tizeti/image/upload/v1542971012/Group-1.png" alt="img" />
                </span>
                <small>BaseStations</small>
              </Link>
            </li>

           

          <AssetTeamSideBarItem url="/fibre-requisitions" name="Requisitions" />



        
    

          

        
          </span>
        </ul>
      </nav>
    </div>
  );
};

export default FibreSideBar;
